import { Theme as ITheme } from '@material-ui/core';

export const styles = (theme: ITheme) => {
    return {
        message: {
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        container: {
            width: '100%',
        },
        header: {
            display: 'flex',
            color: theme.palette.common.white,
            background: theme.palette.primary.dark,
            fontWeight: 'normal' as 'normal',
            textTransform: 'uppercase' as 'uppercase',
            padding: `${theme.spacing(1.5)}px ${theme.spacing(2.5)}px`,
            position: 'relative',
            zIndex: 11,
        },
        title: {
            fontSize: '2.2em',
            display: 'flex',
            alignItems: 'center',
            minWidth: theme.spacing(30),
        },
        menuHover: {
            '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                cursor: 'default',
            },
        },
        select: {
            color: 'rgba(255, 255, 255, 0.5)',
        },
        formControl: {
            width: 300,
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.2)',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.5)', // border color on hover
            },
        },
        sort: {
            display: 'flex',
            flex: '1',
            alignItems: 'center',
            justifyContent: 'flex-end',
            textTransform: 'none' as 'none',
            '& > span': {
                marginRight: theme.spacing(1.5),
            },
            margin: `38px ${theme.spacing(2.5)}px 8px ${theme.spacing(2.5)}px`,
        },
        selectIcon: {
            width: '8px',
            height: 'auto',
            top: '50%',
            transform: 'translate(-50%, -50%)',
        },
        uploadButton: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
            fontSize: '14px',
            padding: `6px ${theme.spacing(2.5)}px`,
            maxHeight: '40px',
            borderRadius: '24px',
            textTransform: 'none' as 'none',
            margin: `38px ${theme.spacing(2.5)}px 8px ${theme.spacing(2.5)}px`,
            transition: 'background-color 0.1s ease-in-out',
            '&:hover': {
                backgroundColor: '#B3211E',
            },
        },
        scrollBar: {
            minHeight: `calc(100vh - ${theme.spacing(8)}px)`,
            height: `calc(100vh - ${theme.spacing(8)}px)`,
            display: 'flex',
            flexWrap: 'wrap' as 'wrap',
            overflowX: 'hidden' as 'hidden',
            overflowY: 'scroll' as 'scroll',
            position: 'relative' as 'relative',
            zIndex: 1000,
            '&::-webkit-scrollbar': {
                width: '0.8em',
                backgroundColor: 'grey',
                borderRadius: theme.spacing(1.25),
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: '#424242',
                borderRadius: theme.spacing(1.25),
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: theme.palette.common.white,
                borderRadius: theme.spacing(1.25),
            },
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
            },
        },
    };
};
